import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';

/**
 * @param {number} tenantId - ID of the tenant
 * @param {number} profileType - ID of the profile
 * @param {import('@tanstack/react-query').UseQueryOptions} [config] - Query config
 */
const useProfileSubmodules = (tenantId, profileId, config) => {
  const api = useApi();

  return useQuery({
    queryKey: ['tenants', +tenantId, 'smf', 'profiles', +profileId, 'submodules'],

    queryFn: () => {
      return api.get(`/tenants/${tenantId}/smf/profiles/${profileId}/submodules`);
    },

    ...config,
  });
};

export default useProfileSubmodules;
